var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconRubricLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconRubric",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true,
      children: _path || (_path = _jsx("path", {
        d: "M1344.962 112.94C1321.584 47.324 1259.466 0 1185.942 0H734.177c-73.525 0-135.643 47.323-159.022 112.94H113V1920h1694.118V112.94h-462.156Zm349.214 1694.119H225.942V225.882h338.823v225.884h790.589V225.882h338.822v1581.177ZM677.706 225.882v-56.47c0-31.171 25.299-56.471 56.47-56.471h451.766c31.172 0 56.47 25.3 56.47 56.472v169.412H677.706V225.882Zm-225.86 790.589h338.823V677.647H451.846v338.824Zm112.941-112.942h112.941V790.588H564.787v112.941Zm338.824-112.941h564.707V677.647H903.611v112.941Zm0 564.706h564.707v-112.941H903.611v112.941Zm0-338.823h338.823V903.529H903.611v112.942Zm0 564.706h338.823v-112.941H903.611v112.941Zm-338.824-112.942h112.941v-112.941H564.787v112.941Zm-112.941 112.942h338.823v-338.824H451.846v338.824Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconRubricLine.glyphName = 'rubric';
IconRubricLine.variant = 'Line';
IconRubricLine.displayName = 'IconRubricLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconRubricLine.propTypes = {
  ...SVGIcon.propTypes
};
IconRubricLine.allowedProps = [...SVGIcon.allowedProps];
export default IconRubricLine;
export { IconRubricLine };